<ng-template [ngIf]="isRifiutandoPreventivo">
  <app-loading></app-loading>
</ng-template>
   <div class="d-flex mt-2">
      <form [formGroup]="rifiutaPreventivoForm">
        <div class="grid formgrid p-fluid">
          <div class="field col-12">
            <label for="noteRifiutoPreventivo" class="font-small text-900 text-blue-900">Motivazione del rifiuto</label>
              <span class="p-input-icon-left">
                <i class="pi pi-info-circle"></i>
                <textarea id="noteRifiutoPreventivo" rows="5" [autoResize]="true" formControlName="noteRifiutoPreventivo" pInputTextarea></textarea>
              </span>
          </div>
        </div>
      </form>
   </div>

    <div class="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
    <div class="margin-top-1" style="text-align: center; display: flex; justify-content: center; align-items: center;">
      <p-button icon="pi pi-times" (onClick)="conferma(false)" label="Annulla" class="p-button-text mr-2"
      styleClass="p-button-warning"></p-button>
     <p-button  icon="pi pi-check" label="Conferma"
      class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)" [disabled]="isRifiutandoPreventivo || !rifiutaPreventivoForm.valid"></p-button>
  </div>
    <p-toast />
    <p-confirmDialog /> 